import { useRef } from 'react'
import { Form, useFormikContext } from 'formik'

import Modal from 'components/Modal'
import { SpySidebar } from 'components/shared/SpySidebar'

import { updateSettingsVisibility } from 'components/RevenueCenters/utils'
import { HIDEABLE_REVENUE_CENTERS_SECTIONS } from 'resources'

const RevenueCenter = ({
  settings,
  showValidationErrors,
  onClickSaveButton,
  disableUpdateButton,
  revenueCenterUuid,
  onCloseModal,
  isLoading,
  onFormKeyDown,
}) => {
  const itemSettingsRef = useRef()

  const { dirty, errors, isSubmitting, touched, values } =
    useFormikContext()

  const isRevenueCenterImageTouched = !!touched?.revenueCenterImage
  const isMenuImagesTouched = !!touched?.menuImages
  const isImageFieldTouched =
    isRevenueCenterImageTouched || isMenuImagesTouched

  const isNewRevenueCenter = revenueCenterUuid === 'new'
  const modalTitle = isNewRevenueCenter
    ? 'Add a Revenue Center'
    : 'Edit Revenue Center'

  const updatedSettings = updateSettingsVisibility(
    settings,
    values?.standsSettings?.provide_tip_suggestions,
    HIDEABLE_REVENUE_CENTERS_SECTIONS
  )

  return (
    <Modal
      title={modalTitle}
      onClose={onCloseModal}
      onRequestClose={onCloseModal}
      isLoading={isLoading}
    >
      <div className="modal-body">
        <Form onKeyDown={onFormKeyDown}>
          <div className="item-settings" ref={itemSettingsRef}>
            <p className="description">
              <span className="color-danger">*</span> indicates a
              required field
            </p>
            {settings.map(({ Component, ref, text, ...props }) => (
              <section
                key={text}
                className="item-settings__section"
                ref={ref}
                id={text}
              >
                <Component
                  {...props}
                  key={text}
                  title={text}
                  showValidationErrors={showValidationErrors}
                />
              </section>
            ))}
            <div className="btn-wrapper">
              <button
                className="btn -update"
                onClick={onClickSaveButton}
                disabled={
                  disableUpdateButton(dirty, errors, isSubmitting) &&
                  !isImageFieldTouched
                }
                type="submit"
                data-cy="save-button"
              >
                Save
              </button>
            </div>
          </div>
        </Form>
        <SpySidebar
          settings={updatedSettings}
          root={itemSettingsRef?.current}
        />
      </div>
    </Modal>
  )
}

export default RevenueCenter
